export const GROUP_TYPES: Record<number, { name: string, value: number }> = {
  1: { name: 'Rubicon', value: 1 },
  2: { name: 'BPO', value: 2 }
};
